import '.a{display:flex;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.cs{background:var(--shades-white);}.ssr-plugin'
import '.bo{flex-grow:1;}.ssr-plugin'
import '.n{align-items:center;}.ssr-plugin'
import '.b5{max-width:77.5rem;}.ssr-plugin'
import '.ct{justify-content:stretch;}.ssr-plugin'
import '.cu{position:sticky;}.ssr-plugin'
import '.cm{top:0;}.ssr-plugin'
import '.cv{z-index:10;}.ssr-plugin'
import '.cw{padding-block:1rem;}.ssr-plugin'
import '.cx{height:3rem;}.ssr-plugin'
import '.a5{justify-content:space-between;}.ssr-plugin'
import '.cy{flex-wrap:wrap;}.ssr-plugin'
import '.cz{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.b3{margin-top:2rem;}.ssr-plugin'
import '.g3{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const InitiativeCreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="a ab b m cs"
      >
        <div className="bo a n b m"
        >
          <div className="b5 a m ct cu cm cv"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="cw cx a a5 n cy"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="cz a m ab b3 g3 b5"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%', // 8rem is padding + navbar height
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
